import React, { useEffect, useState } from "react";
import ProcessBar from "../MainComponent/processBar";
import FinancialsInfo from "./financialsInfo";
import "./financials.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleInverterType } from "../Electricals/electricalFunction";
import { inverterInformation } from "../../DataFiles/inverterInformation";

export default function FinancialsDetail() {
  const [emptyValues, setEmptyValues] = useState(false);
  const projectId = useSelector((state) => state.roof.id);
  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;

  const roofDetail = roofData[roofIndex];
  let inverterDetail = [];

  if (quantityInfo.electricalConfiguration === "All Roof") {
    inverterDetail = roofInfo.value.inverterAnalysis;
  } else {
    inverterDetail = roofDetail.inverterAnalysis;
  }

  useEffect(() => {
    const value = inverterDetail;
    if(inverterDetail){
      let inverter = inverterInformation.find(
        (item) =>
          item.brand === value.inverterManufacturer &&
          item.phase === value.inverterPhase &&
          item.systemType === value.systemType
      );
      let type = inverter.inverterType.find(
        (item) => item.name === value.inverterType
      );
      setTimeout(() => {
        handleInverterType({
          type,
          dispatch,
          roofInfo,
          roofDetail,
          inverterDetail,
          quantityInfo,
        });
      }, 100);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="financialDetails">
        <div className="financialHead">
          <div className="financialHeader">
            <Link to="/Dashboard">
              <h6 style={{ color: "#FF7C1B" }}>My Project</h6>
            </Link>
            <h6>/</h6>
            {!projectId ? <h6>Create Project</h6> : <h6>Edit Project</h6>}
          </div>
          <ProcessBar setEmptyValues={setEmptyValues}></ProcessBar>
        </div>
        <FinancialsInfo
          emptyValues={emptyValues}
          setEmptyValues={setEmptyValues}
        ></FinancialsInfo>
      </div>
    </>
  );
}
